import { ReactNode } from 'react'
import BaseListOptions from './base-list-option'
import { AsHeadlessType } from './common-list-option'
import { DataInterface, ExtendedDataType, GroupDataInterface } from './editable-form-select'

interface BaseListProps<T extends ExtendedDataType> {
  data?: T[]
  value?: DataInterface<T>['id']
  getOptionDataAttribute?: (value?: string) => void
  groups?: GroupDataInterface[]
  optionIconRenderer?: (data?: T) => ReactNode | undefined
  as: AsHeadlessType
}

function BaseList<T extends ExtendedDataType>({
  data,
  value,
  getOptionDataAttribute,
  groups,
  optionIconRenderer,
  as,
}: BaseListProps<T>) {
  return (
    <div className="customScroll max-h-60 w-full border-collapse overflow-auto rounded-md border border-text-secondary/30 bg-background-secondary text-sm focus:outline-none">
      {groups ? (
        groups.map(group => (
          <BaseListOptions
            data={data}
            group={group}
            value={value}
            getOptionDataAttribute={getOptionDataAttribute}
            optionIconRenderer={optionIconRenderer}
            key={group.id}
            as={as}
          />
        ))
      ) : (
        <BaseListOptions
          data={data}
          value={value}
          getOptionDataAttribute={getOptionDataAttribute}
          optionIconRenderer={optionIconRenderer}
          as={as}
        />
      )}
    </div>
  )
}

export default BaseList
